import React, { useState } from "react";
import YearsDropdown from "components/dropdown/yearsDropdown";
import QuartersDropdown from "components/dropdown/quartersDropdown";

const ManageDateFilter = ({className=""}) => {
  const [quarter, setQuarter] = useState("");
  const [year, setYear] = useState("");

  return (
    <div className={`row flex-1 ${className}`} style={{ padding: 10 }}>
      <QuartersDropdown
        value={quarter}
        onChange={(event) => setQuarter(event.target.value)}
        className="col-xl-3 col-6 col-md-6 col-sm-6"
      />
      <YearsDropdown
        value={year}
        className="col-xl-3 col-6 col-md-6 col-sm-6"
        onChange={(event) => setYear(event.target.value)}
      />
    </div>
  );
};

export default ManageDateFilter;
